module.exports = __webpack_public_path__ + "static/media/first-page-slide7.7ba0296b.jpg";